import React, { useEffect, useState } from "react";
import "./ContactUsBottomSheet.css";

const ContactUsBottomSheet = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Thank you for contacting us! We will get back to you soon.");
    setFormData({ name: "", email: "", subject: "", message: "" });
    onClose();
  };

  return (
    <>
      <div
        className={`contact-overlay ${isOpen ? "show" : ""}`}
        onClick={onClose}
      ></div>
      <div className={`contact-bottom-sheet ${isOpen ? "show" : ""}`}>
        <div className="contact-sheet-header">
          <div className="contact-drag-handle" onClick={onClose}></div>
          <button className="contact-close-btn" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="contact-sheet-content">
          <div className="contact-header-section">
            <h1 className="contact-title contact-font-heading contact-text-primary">
              Get in Touch
            </h1>
            <p className="contact-subtitle">
              Have a question about our products, a recent order, or want to
              partner with us? We'd love to hear from you.
            </p>
          </div>

          <div className="contact-grid">
            <div className="contact-info-card">
              <h3 className="contact-info-title contact-font-heading">
                Contact Information
              </h3>

              <div className="contact-info-item">
                <i className="fas fa-map-marker-alt contact-info-icon"></i>
                <div className="contact-info-text">
                  <h4>Our Store </h4>
                  <p>
                    42 Town Centre, Hatfield Near Post Office Hertfordshire,
                     <br />
                    AL10 0JT
                  </p>
                </div>
              </div>

              <div className="contact-info-item">
                <i className="fas fa-envelope contact-info-icon"></i>
                <div className="contact-info-text">
                  <h4>Email Us</h4>
                  <p>
                   aarohfood@gmail.com 
                    <br />
                   
                  </p>
                </div>
              </div>

              <div className="contact-info-item">
                <i className="fas fa-phone-alt contact-info-icon"></i>
                <div className="contact-info-text">
                  <h4>Call Us</h4>
                  <p>
                     01707 269944
                    <br />
                     Mon–Sun, 8:00 AM – 7:00 PM 
                  </p>
                </div>
              </div>
            </div>

            <div className="contact-form-card">
              <h3 className="contact-form-title contact-font-heading">
                Send us a Message
              </h3>
              <form onSubmit={handleSubmit}>
                <div className="contact-form-row">
                  <div className="contact-form-group">
                    <label className="contact-label">Full Name</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="contact-input"
                      placeholder="John Doe"
                      required
                    />
                  </div>
                  <div className="contact-form-group">
                    <label className="contact-label">Email Address</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="contact-input"
                      placeholder="john@example.com"
                      required
                    />
                  </div>
                </div>
                <div className="contact-form-group">
                  <label className="contact-label">Subject</label>
                  <input
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    className="contact-input"
                    placeholder="How can we help you?"
                    required
                  />
                </div>
                <div className="contact-form-group">
                  <label className="contact-label">Message</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="contact-textarea"
                    placeholder="Write your message here..."
                    required
                  ></textarea>
                </div>
                <button type="submit" className="contact-submit-btn">
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUsBottomSheet;
